// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2pnpG","buttons":"Footer_buttons__3PpZ0"};